import { useTranslation } from "react-i18next";

const Ingredients = ({ ingredients }) => {
  const { t } = useTranslation();

  if (!Array.isArray(ingredients)) return null;

  return (
    <div className="container mt-10">
      <div className="row justify-content-center">
        <div className="col-12">
          <h2 className="mb-1 text-black">{t("recipe.ingredients", "Ingredients")}</h2>
          <ol className="list-group list-group-separated col-12">
            {ingredients
              .map((item, idx) => (
                <li
                  key={idx}
                  className="list-group-item d-flex justify-content-between align-items-start text-black"
                >
                  <span>
                    <p className="lead mt-0" style={{ lineHeight: "90%", textTransform: "uppercase" }}>{item.title}</p>
                  </span>
                  {item.quantity && (
                    <p className="lead mt-0" style={{ lineHeight: "90%", textTransform: "uppercase", textAlign: "right" }}>
                      {item.quantity}
                    </p>
                  )}
                </li>
              ))}
          </ol>
        </div>
      </div>
    </div>
  );
};

export default Ingredients;
